import { useMutation } from '@tanstack/react-query'

import api from './api'

const matchCensusPreSignup = values => api.post('/presignup/census-match/', values)
export const useMatchCensusPreSignup = options => useMutation(matchCensusPreSignup, options)
